import userMutations from "./mutations.js";
import userActions from "./actions.js";
import userGetters from "./getters.js";

export default {
  namespaced: true, // put true if want enable modules
  state() {
    // The signed-in user is not kept here. A copy taken at sign in is a copy of
    // whoever signed in first, and nothing invalidates it when the next person
    // signs in without reloading. The user getter reads the reactive session
    // instead - see src/utils/session.js.
    return {};
  },
  mutations: userMutations,
  actions: userActions,
  getters: userGetters,
};
